import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialog } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacySlideToggleChange, MatLegacySlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { HintIconComponent } from '../../../../hint-icon/hint-icon.component';
import { arlFormUpdateQuantityByQuantityHistory } from '../arl-calculation.helper';
import { arlTableDataArlForm } from '../arl-form-data.service';
import { QuantityHistoryModalComponent } from '../quantity-history-modal/quantity-history-modal.component';

@Component({
    selector: 'app-arl-amount-calculation-view',
    standalone: true,
    imports: [
        CommonModule,
        MatLegacySlideToggleModule,
        HintIconComponent,
        MatLegacyButtonModule,
        FontAwesomeModule,
        MatLegacyFormFieldModule,
        MatLegacyInputModule,
        ReactiveFormsModule,
        MatLegacyTooltipModule,
        QuantityHistoryModalComponent,
    ],
    templateUrl: './arl-amount-calculation-view.component.html',
    styleUrls: ['./arl-amount-calculation-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArlAmountCalculationViewComponent {
    @Input() expanded = false;
    protected _quantityHistoryForm: FormGroup<Pick<arlTableDataArlForm['controls'], 'Quantity' | 'UseQuantityHistory' | 'QuantityHistory' | 'ShowQuantityHistory'>> = null;

    @Input() set quantityHistoryForm(v: typeof this._quantityHistoryForm) {
        this._quantityHistoryForm = v;
        this.addQuantityHistoryForm.reset();
    }
    protected addQuantityHistoryForm = new FormControl<number | null>(null);
    constructor(private dialog: MatLegacyDialog) {}
    updateQuantityByQuantityHistory() {
        arlFormUpdateQuantityByQuantityHistory(this._quantityHistoryForm);
    }

    quantityCalculated(quantity: number) {
        // this.updateQuantityByQuantityHistory();
        if (this._quantityHistoryForm.controls.UseQuantityHistory.getRawValue() && quantity !== this._quantityHistoryForm.controls.Quantity.getRawValue()) {
            this._quantityHistoryForm.controls.Quantity.setValue(quantity);
            this._quantityHistoryForm.controls.Quantity.markAsDirty();
        }
    }

    onUseQuantityHistoryChange(change: MatLegacySlideToggleChange) {
        if (this._quantityHistoryForm.controls.UseQuantityHistory.getRawValue() !== change.checked) {
            this._quantityHistoryForm.controls.UseQuantityHistory.markAsDirty();
            this._quantityHistoryForm.controls.UseQuantityHistory.setValue(change.checked);
        }
        if (change.checked) {
            this.updateQuantityByQuantityHistory();
        } else if (this._quantityHistoryForm.controls.ShowQuantityHistory.getRawValue()) {
            this._quantityHistoryForm.controls.ShowQuantityHistory.markAsDirty();
            this._quantityHistoryForm.controls.ShowQuantityHistory.setValue(false);
        }
    }
}
